import Responsive from './Responsive';
import Swiper from 'swiper';

module.exports = function() {
	const r = new Responsive();

	const btn = $('.tab-hasnum-ctrl');
	const target = $('.tab-hasnum-content.pc');
	let index;

	$(window).on('load',function(){
		if(r.state()()){
			$('.tab-hasnum-content.pc').eq(0).show();
		}else{
			$('.tab-hasnum-content.sp.wrap_1').html($('.tab-hasnum-content.pc').eq(0).html()).show();
		}
	});
	btn.click(function() {
		if(r.state()()){
			index = btn.index(this);

			target.css('display','none');
			target.eq(index).css('display','block');

			btn.removeClass('active');
			$(this).addClass('active');

			return false;
		}else{
			index = btn.index(this);
			$('.tab-hasnum-content.sp.wrap_1,.tab-hasnum-content.sp.wrap_2').hide()
			let content = target.eq(index).html();
			if(index == 0 || index == 1){
				$('.tab-hasnum-content.sp.wrap_1').html(content).show();
			}else{
				$('.tab-hasnum-content.sp.wrap_2').html(content).show();
			}

			btn.removeClass('active');
			$(this).addClass('active');

			return false;
		}

	});
}



// WEBPACK FOOTER //
// ./dev/js/scripts/tab_num.js